import { Alert, Card, createTheme, mergeThemeOverrides } from '@mantine/core';
import { theme } from '@backoffice-client/styles/theme.js';

/**
 * The backoffice's theme, plus the hub's own card surface: every card is `--rgs-surface` behind
 * the `--rgs-line` hairline, in both schemes. A card's own `style` still wins (a sticky rail's
 * position, a table card's `overflow`).
 *
 * The hub's alerts carry buttons (the inbox banner's **Adopt n from env**, an error's **Retry**),
 * and Mantine's alert message is `overflow: hidden` (for its ellipsis) and exactly as tall as
 * its content — so a focused button's ring, drawn 2px outside it, was cut off. The root keeps
 * its own `overflow: hidden`, with padding enough for the ring.
 */
export const hubTheme = mergeThemeOverrides(
    theme,
    createTheme({
        components: {
            Card: Card.extend({
                styles: { root: { background: 'var(--rgs-surface)', borderColor: 'var(--rgs-line)' } },
            }),
            Alert: Alert.extend({ styles: { message: { overflow: 'visible' } } }),
        },
    }),
);
